module.exports = __webpack_public_path__ + "img/nitrite.5b660900.png";